<template>
    <div id="echart-network" :style="{ height: '800px',width:'100%'}" ></div>   
</template>

<script>

var myChart;
var option;
export default({
    props:{
        nodes:Array,
        edges:Array,
    },
    data(){
        return{
            categories:[
                {name: 'SNP'},
                {name: 'Gene'},
                {name: 'RNA'},
                {name: 'Methylation'},
            ],
        }
    },
    watch:{
        nodes(){
            this.initChart()
        }
    },
        
    methods: {
        initChart() {
            // 如果已存在视图实例，则先销毁后创建
            if (myChart != null && myChart != "" && myChart != undefined) {
                myChart.dispose();
            }
            // 基于准备好的dom，初始化echarts实例
            myChart = this.echarts.init(document.getElementById("echart-network"));
            option = {
                tooltip: {
                    formatter: function (param) {
                        var value = param.data;
                        if(value['source']){
                            return value['source'] + '--' +value['target']+'<br>'
                                    + 'Score: ' + value['score'] + '<br>' 
                        }
                        else if(value['category']=='SNP'){
                            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                                    + value['name']
                                    + '</div>'
                                    + 'Gene name: ' + value['gene'] + '<br>'
                                    + 'Allele: ' + value['allele'] + '<br>'  
                                    + 'Position: ' + value['position'] + '<br>' 
                        }else if(value['category']=='Gene'){
                            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                                    + value['name']
                                    + '</div>'
                                    + 'Gene ID: ' + value['gene_id'] + '<br>'
                                    + 'Location: ' + value['location'] + '<br>' 
                                    + 'Type: ' + value['type'] + '<br>'  
                        }else if(value['category']=='RNA'){
                            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                                    + value['name']
                                    + '</div>'
                                    + 'Gene ID: ' + value['gene_id'] + '<br>'
                                    + 'Original name: ' + value['rna_name'] + '<br>'
                                    + 'Location: ' + value['location'] + '<br>' 
                                    + 'Type: ' + value['type'] + '<br>'  
                        }else if(value['category']=='Methylation'){
                            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                                    + value['name']
                                    + '</div>'
                                    + 'Gene name: ' + value['gene_name'] + '<br>'
                                    + 'Gene ID: ' + value['gene_id'] + '<br>'
                                    + 'Probe ID: ' + value['probe'] + '<br>'
                                    + 'Location: ' + value['location'] + '<br>' 
                        }
                    }
                },
                title: {
                    // text: 'Chromosome'
                },
                toolbox: {
                    right: 100,
                    top:50,
                    feature: {
                        restore: {
                            title:"Restore"
                        },
                        saveAsImage: {
                            title:"Download as image"
                        }
                    }
                },
                legend: [
                    {
                        orient: 'vertical',
                        left: 10,
                        top:40,
                        data: this.categories.map(function (a) {
                            return a.name;
                        })
                    }
                ],
                animationDuration: 500,
                animationEasingUpdate: 'quinticInOut',
                series: [
                {
                    type: 'graph',
                    layout: 'circular',
                    draggable: true,
                    categories:this.categories,
                    data:  this.nodes,
                    links: this.edges,
                    roam: true,
                    label: {
                        position: 'right',
                        show:true,
                    },
                    emphasis: {
                        focus: 'adjacency',
                        lineStyle: {
                            width: 10
                        }
                    },
                    lineStyle: {
                        color: 'source',
                        curveness: 0.3
                    },
                    edgeSymbol: ['none', 'arrow'],
                },
                

                ]
            };
            myChart.setOption(option);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
    }
})
</script>
